
import { NavigationKey } from '../../../types';

export const navigation: Record<NavigationKey, string> = {
  welcome: 'Bienvenido',
  dashboard: 'Panel',
  myVideos: 'Mis Videos',
  analytics: 'Análisis',
  settings: 'Configuración',
  profile: 'Perfil',
  logout: 'Cerrar Sesión',
  feed: 'Noticias',
  latestVideos: 'Videos Recientes',
  finance: 'Finanzas',
  support: 'Soporte',
  tracking: 'Seguimiento',
  integrations: 'Integraciones',
  security: 'Seguridad',
  partners: 'Socios',
  help: 'Ayuda',
  início: 'Inicio',
  novoVídeo: 'Nuevo Video',
  personalização: 'Personalización',
  funnelVideo: 'Embudo de Video',
  vsleads: 'VSLeads',
  métricas: 'Métricas',
  testeAB: 'Test A/B',
  hookTrack: 'Teste de hook',
  rastreamento: 'Seguimiento',
  integrações: 'Integraciones',
  segurança: 'Seguridad',
  proteçãoDomínios: 'Protección de Dominios',
  cloakerVSL: 'Cloaker VSL',
  parceiros: 'Socios',
  membros: 'Miembros',
  botaoAcao: 'Botón de Acción',
  ajuda: 'Ayuda',
  masterClass: 'Master Class',
  compartilhar: 'Compartir',
  capturaLeads: 'Captura de Leads',
  dominios: 'Dominios',
  chat: 'Chat',
  centralAjuda: 'Centro de Ayuda',
  cloaker: 'Cloaker',
  personalizar: 'Personalizar',
};
